import React from 'react';

import { SimpleObject } from '@clearverify/types';

import { Modal } from 'src/components/common';
import { PeoPayrollProviderStaffDetailsModalForm } from 'src/components/peoPayrollProviderStaff';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

export interface PeoPayrollProviderStaffDetailsModalArgs extends SimpleObject {
  peoPayrollProviderStaffId: string;
  peoPayrollProviderId: string;
}

export const PeoPayrollProviderStaffDetailsModal: React.FC = () => {
  const { closeModal, switchClosability, isOpen, args } =
    useModal<PeoPayrollProviderStaffDetailsModalArgs>(ModalId.PeoPayrollProviderStaffDetailsModal);

  const handleCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      title="Staff Details"
      dialogProps={{
        onClose: handleCloseModal,
        open: isOpen,
      }}
      maxWidth={600}
    >
      <PeoPayrollProviderStaffDetailsModalForm
        peoPayrollProviderStaffId={args?.peoPayrollProviderStaffId}
        onCloseModal={handleCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
